/* istanbul ignore file */
import { useEffect, useState } from 'react';
import { getPMData } from 'common/services/pm.service';
import {
  formatAdditionalTypesToFilters,
  formatSelectedFiltersToAdditionalTypes
} from './additional-types.utils';
import { useSelector } from 'react-redux';
import { pmIntegrationSelector } from 'state/selectors/sensors-authorizations';
import { SENSOR_STATES } from '@linearb/linjs-common';
import { FILTER_TYPES, filterFormatter } from 'common/constants/filters';

const useAdditionalTypes = ({ additionalTypes = [], setAdditionalTypes }) => {
  const pmSensor = useSelector(pmIntegrationSelector);

  const isAuthorized = pmSensor?.state === SENSOR_STATES.ok;
  const [selectedFilters, setSelectedFilters] = useState(() =>
    formatAdditionalTypesToFilters(additionalTypes)
  );

  const [isLoadingFilters, setIsLoadingFilters] = useState(false);
  const [customFields, setCustomFields] = useState([]);
  const [labels, setLabels] = useState([]);
  const formattedCustomFields =
    filterFormatter[FILTER_TYPES.FIELD](customFields);
  const formattedLabels = filterFormatter[FILTER_TYPES.LABEL](labels);

  const fetchData = async () => {
    setIsLoadingFilters(true);
    const pmData = await getPMData(isAuthorized, pmSensor?.sensor_id);
    setCustomFields(pmData.customFields);
    setLabels(pmData.labels);
    setIsLoadingFilters(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setAdditionalTypes(formatSelectedFiltersToAdditionalTypes(selectedFilters));
  }, [selectedFilters]);

  return {
    selectedFilters,
    setSelectedFilters,
    customFields: formattedCustomFields,
    labels: formattedLabels,
    isLoadingFilters
  };
};

export default useAdditionalTypes;
